import styled from "styled-components"

export const StyledMenu = styled.nav`
  align-items: center;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.heading};
  height: 100%;
  justify-content: flex-start;
  left: 0;
  padding: 2rem;
  position: fixed;
  text-align: center;
  top: 0;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-100%)")};
  transition: transform 0.3s ease-in-out;
  width: 99vw;
  z-index: 10;

  a {
    color: ${props => props.theme.colors.primary};
    font-weight: 400;
    max-width: 15em;
    opacity: 0.9;
    padding-bottom: 0.25em;
    padding: 2.5em 0 0.5em;
    text-decoration: none;
    transition: border-bottom 0.5s;
    text-transform: uppercase;

    &:hover {
      border-bottom: 2px solid ${props => props.theme.colors.highlight};
      opacity: 1;
    }
  }
`
